// removed by extract-text-webpack-plugin
module.exports = {"colSpan":"CentricUI__SecondariesAdoptionRegion__AdoptionRegionView__colSpan","root":"CentricUI__SecondariesAdoptionRegion__AdoptionRegionView__root","row":"CentricUI__SecondariesAdoptionRegion__AdoptionRegionView__row","header":"CentricUI__SecondariesAdoptionRegion__AdoptionRegionView__header","total":"CentricUI__SecondariesAdoptionRegion__AdoptionRegionView__total","label":"CentricUI__SecondariesAdoptionRegion__AdoptionRegionView__label"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/SecondariesAdoptionRegion/AdoptionRegionView.css
// module id = 991
// module chunks = 10